export enum MapActionType {
    Areas = 1,
}
